import { gql } from '@apollo/client';

const query = gql`
  query reviews($userId: String, $after: String, $first: Int) {
    reviews(userId: $userId, after: $after, first: $first) {
      edges {
        cursor
        node {
          id
          userId
          rating
          displayName
          reviewState
          message
          createdAt
          listing {
            name
            hash
            profileUrl
            online
            logo
            vanityUrlPath
            listingLocations {
              suburb {
                name
                state
              }
            }
          }
          reviewResponse {
            message
            id
          }
          reviewAssets {
            edges {
              node {
                id
                url
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

module.exports = query;
